import { escapeRegExp } from 'lodash';

export default class TextHighlighter {
    highlight(text: string, terms: string[], attribute: string) {
        const re = new RegExp(terms.map(t => escapeRegExp(t)).join('|'), 'gi');

        return text.replace(re, match => {
            return `<span ${attribute}>${match}</span>`;
        });
    }
}



// WEBPACK FOOTER //
// ./js/marketing/utils/TextHighlighter.ts